import NumberType from "../../types/Number";

export const getBadgeCount = (count: number, max?: number): string => {
    if (!max) {
        max = 99;
    }

    return count > max ? `${NumberType.format(max)}+` : NumberType.format(count);
};